"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.props = void 0;
var withCompInfo_1 = require("../../core/withCompInfo");
var staticAudioUrl = 'https://music.wixstatic.com/mp3'; // TODO add to topology
exports.props = withCompInfo_1.withCompInfo(['compData', 'skin'], function (_a) {
    var compData = _a.compData, skin = _a.skin;
    return {
        skin: skin || 'SimplePlayer',
        playlist: [{ url: staticAudioUrl + "/" + compData.uri }],
        autoPlay: compData.autoPlay,
        loop: compData.loop,
        volume: compData.volume / 100,
        originalFileName: compData.originalFileName,
    };
});
//# sourceMappingURL=AudioPlayer.js.map